export default "__VITE_ASSET__05932b47__"